import script from "./CollectionFinal.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFinal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__